module.exports = __webpack_public_path__ + "img/rooms.8afcb261.svg";